import PropTypes from 'prop-types';
import React from 'react';
import { GoogleDFP } from '@surfline/quiver-react';
import loadAdConfig from '../../utils/adConfig';

const CompanionAd = ({ spotId, entitlements }) => {
  const adTargets = [['spotid', spotId]];
  const adConfig = loadAdConfig('spotReportPosition2', adTargets, entitlements);
  return <GoogleDFP unifiedAdMarketplace companion adConfig={adConfig} />;
};

CompanionAd.propTypes = {
  spotId: PropTypes.string.isRequired,
  entitlements: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CompanionAd;
